import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FollowButton } from 'react-activity-feed';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';

import global from '../../stores/GlobalStore';
import { getQueryParamNoHash } from '../../utils/http';
import history from '../../auth/history';
import DefaultAvatarCircle from '../../styles/images/DefaultAvatarCircle.png';
import User from '../../models/User';
import getCategories from '../../data/categories';

import 'react-web-tabs/dist/react-web-tabs.css';
import 'react-activity-feed/dist/index.css';
import '../Home/styles/TimelinePage.scss';
import './UserProfile.scss';

const emailProviders = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'msn.com',
  'icloud.com',
  'hey.com',
  'aol.com',
  'mail.com',
  'zoho.com',
];

export default class UserProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFollowing: false,
      userId: this.getUserId() || '',
      userDetails: this.getUserDetails() || new User({}),
      shows: {},
      userCategories: [],
      categories: getCategories(),
      startTab: getQueryParamNoHash('t') || 'shows',
    };

    this.allowUserFollowing = false;
    this.fetchUserShows();
  }

  getUserDetails = () => {
    global()
      .getUserStore()
      .getUserDetails(this.getUserId(), result => {
        if (result) {
          const userDetails = new User(result);
          let isFollowing;

          if (this.props.user) {
            isFollowing = userDetails.followers && userDetails.followers.includes(this.props.user.id);
          } else {
            isFollowing = false;
          }

          this.setState({ userDetails, isFollowing, userCategories: userDetails.categories || [] });
        }
      });
  };

  fetchUserShows = () => {
    if (this.state.userId) {
      global()
        .getPodcastStore()
        .fetchUserFollowedShows(this.state.userId, shows => {
          this.setState({ shows });
        });
    }
  };

  updateUserCategories = newCategory => {
    const { userCategories, userDetails } = this.state;
    let results = _.clone(userCategories);

    if (userCategories.indexOf(newCategory) > -1) {
      results = _.remove(userCategories, category => {
        return category !== newCategory;
      });
    } else {
      results.push(newCategory);
    }

    this.setState({ userCategories: results });

    if (this.state.userId) {
      localStorage.setItem('categories', results);
      global()
        .getUserStore()
        .updateUserCategories(this.state.userId, userDetails.email, results);
    }
  };

  getUserId = () => {
    const { pathname } = this.props.location;
    if (pathname) {
      const pathArray = pathname.split('/');
      return pathArray[2];
    }
  };

  followUser = () => {
    if (this.props.user) {
      this.setState({ isFollowing: true });

      global()
        .getUserStore()
        .followUser(this.state.userId, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: false });
          }
        });
    }
  };

  unfollowUser = () => {
    if (this.props.user) {
      this.setState({ isFollowing: false });

      global()
        .getUserStore()
        .unfollowUser(this.state.userId, this.props.user.id, result => {
          if (!result) {
            this.setState({ isFollowing: true });
          }
        });
    }
  };

  renderFollowBtn = () => {
    // Don't show the follow button if it's their profile
    if (this.props.user && this.state.userId !== this.props.user.id) {
      return (
        <FollowButton
          onClick={this.state.isFollowing ? this.unfollowUser : this.followUser}
          followed={this.state.isFollowing}
        />
      );
    }
  };

  navToShow = showId => {
    history.push(`/${showId}`);
  };

  renderShows = shows => {
    return Object.keys(shows).map(showId => {
      const show = shows[showId];

      if (show.imageUrl) {
        return (
          <div className='show-container' key={show.id} onClick={this.navToShow.bind(this, show.id)}>
            <img src={show.imageUrl} width={120} className='show-image' alt='' />
            <div className='show-title'>{show.title}</div>
          </div>
        );
      } else {
        return <div className='show-container' key={showId} style={{ display: 'none' }} />;
      }
    });
  };

  renderCategories = categories => {
    const { userCategories } = this.state;

    return Object.keys(categories).map(categoryId => {
      const category = categories[categoryId];

      if (category) {
        return (
          <div
            className={`show-container category ${userCategories.indexOf(categoryId) > -1 ? 'selected' : ''}`}
            key={categoryId}
            onClick={this.updateUserCategories.bind(this, categoryId)}
          >
            <img src={category.imageUrl} width={120} className='category-image' alt='' />
            <div className='show-title'>{category.title}</div>
          </div>
        );
      }

      return null;
    });
  };

  getEmailLink = email => {
    if (email) {
      let result = email.split('@') || [];
      let host = result && result.length && result[1];

      if (host && emailProviders.indexOf(host.toLowerCase()) > -1) {
        return `https://${host}`;
      }
    }
  };

  render() {
    const { darkMode } = this.props;
    const { userDetails, startTab } = this.state;
    const followerCount = userDetails.getFollowerCount() || 0;
    const followingCount = userDetails.getFollowingCount() || 0;
    const avatar = userDetails ? userDetails.getAvatarUrl() : DefaultAvatarCircle;

    console.log(userDetails);

    return (
      <div className='user-feed'>
        <div className='mainPanel' ref='mainPanel' style={{ background: darkMode ? 'rgb(9, 16, 52)' : '' }}>
          <div
            className='user-feed-container user-page'
            style={{
              background: darkMode ? 'rgb(11, 19, 61)' : '',
              borderLeft: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
              borderRight: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
            }}
          >
            {userDetails ? (
              <div
                className='user-detail-container'
                style={{
                  background: darkMode ? 'rgb(11, 19, 61)' : '',
                  borderBottom: darkMode ? '1px solid rgba(255, 255, 255, .2)' : '',
                  color: darkMode ? 'rgba(255, 255, 255, .75)' : '',
                }}
              >
                <div className='user-details'>
                  <div className='user-avatar'>
                    <img src={avatar} alt='user avatar' />
                  </div>
                  {this.allowUserFollowing && (
                    <div className='follow-counts'>
                      <div className='follower-count'>
                        {followerCount === 1 ? `${followerCount} Follower` : `${followerCount} Followers`}
                      </div>
                      <div className='follower-count'>{`${followingCount} Following`}</div>
                    </div>
                  )}
                </div>
                {this.allowUserFollowing && this.renderFollowBtn()}
                {_.size(userDetails) && !userDetails.emailConfirmed && (
                  <div className='confirm-account'>
                    <a href={this.getEmailLink(userDetails.email)} target='_blank' rel='noopener noreferrer'>
                      {`Please Check Your Email and Confirm Your Account - ${userDetails.email}`}
                    </a>
                  </div>
                )}
              </div>
            ) : null}
            <div className='user-profile-body'>
              <Tabs defaultTab={startTab}>
                <TabList>
                  <Tab tabFor='shows'>Shows</Tab>
                  <Tab tabFor='categories'>Categories</Tab>
                </TabList>
                <TabPanel tabId='shows'>
                  <div className='my-shows-container'>
                    <div className='shows-title'>My Shows</div>
                    <div className='show-list-container'>
                      <div className='show-list'>
                        {_.size(this.state.shows) ? (
                          this.renderShows(this.state.shows)
                        ) : (
                          <div>
                            <div>No Shows Followed</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel tabId='categories'>
                  <div className='my-categories-container'>
                    <div className='category-title'>My Categories</div>
                    <div className='category-subtitle'>Select the categories you're interested in</div>
                    <div className='show-list-container'>
                      <div className='show-list'>
                        {this.state.categories && this.renderCategories(this.state.categories)}
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserProfile.propTypes = {
  user: PropTypes.object,
  darkMode: PropTypes.bool,
};

UserProfile.defaultProps = {
  darkMode: false,
};
